import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { CodeSetup } from "src/app/models/GodownCodeSetup/godown-code-setup.model";
import { IGodownCodeSetupRepository } from "./IGodownCodeSetupRepository";

@Injectable()
export class GodownCodeSetupRepository extends GenericRepository<CodeSetup> implements IGodownCodeSetupRepository {
    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/godowncodesetup', environment.urlAddress);
    }
    GetRec(): Observable<any> {
        return this._http
            .get(this.url + 'api/godowncodesetup/Select', this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
}
